var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container summary",
      class: { experiment: _vm.isExperiment, mobile: _vm.isMobile(_vm.$mq) }
    },
    [
      !_vm.isExperiment
        ? [_vm._m(0), _vm._v(" "), _vm._m(1)]
        : [
            _vm._m(2),
            _vm._v(" "),
            _c("section", { staticClass: "content-with-media" }, [
              _c("div", { staticClass: "media-block" }, [
                _c("video", {
                  attrs: {
                    preload: "auto",
                    autoplay: "autoplay",
                    loop: "loop",
                    muted: "muted",
                    playsinline: "playsinline",
                    src:
                      "/site_media/version-V87e099514e4/images/homepage/hands-on-learning.mp4"
                  },
                  domProps: { muted: true }
                })
              ]),
              _vm._v(" "),
              _vm._m(3)
            ]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6)
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h3", [
        _vm._v("\n        Learn key ideas through\n        "),
        _c("strong", [_vm._v("problem solving")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-f234aa6a49/images/homepage/problem-solving-2x.gif",
            alt: "Problem solving"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "unstyled" }, [
      _c("li", [
        _c("h4", [_vm._v("For ages 10 to 110")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Get started as a beginner with the fundamentals, or dive right into intermediate and\n          advanced courses for professionals. Brilliant has courses for ambitious people of all\n          ages.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v("Master essential skills")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Build confidence with hands-on learning. You'll get to see concepts visually, interact\n          with key ideas, and solve challenging problems that get you to really think.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v("Stress less, learn better")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Enjoy fun storytelling, guided problem solving, and making lots of mistakes while\n          playing. On Brilliant, your natural curiosity will drive you, not the threat of a test.\n        "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-block first-block" }, [
      _c("h3", [
        _vm._v("Master concepts in "),
        _c("span", [_vm._v("15 minutes a day")])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        Whether you’re a complete beginner or ready to dive into quantum physics and beyond,\n        Brilliant makes it easy to level up fast with fun, bite-sized lessons.\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-block" }, [
      _c("h3", [_vm._v("Effective, hands-on learning")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n          Visual, interactive lessons make concepts feel intuitive — so even complex ideas just\n          click. Our real-time feedback and simple explanations make learning efficient.\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "content-with-media" }, [
      _c("div", { staticClass: "content-block" }, [
        _c("h3", [_vm._v("Learn at your level")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Students and professionals alike can hone dormant skills or learn new ones. Progress\n          through lessons and challenges tailored to your level. Designed for ages 13 to 113.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "media-block" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-V87e099514e4/images/homepage/learn-at-your-level.svg",
            alt: "Learn at your level"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "content-with-media guided-lessons" }, [
      _c("div", { staticClass: "media-block" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-8e8bc84c0a/images/homepage/guided-lessons.png",
            alt: "Guided bite-sized lessons"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-block" }, [
        _c("h3", [_vm._v("Guided bite-sized lessons")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          We make it easy to stay on track, see your progress, and build your problem solving\n          skills one concept at a time.\n        "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "content-with-media stay-motivated" }, [
      _c("div", { staticClass: "content-block" }, [
        _c("h3", [_vm._v("Stay motivated")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n          Form a real learning habit with fun content that’s always well-paced, game-like progress\n          tracking, and friendly reminders.\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "media-block" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-V87e099514e4/images/homepage/stay-motivated.svg",
            alt: "Stay motivated"
          }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }